import Vue from 'vue'
import Vuex from 'vuex'
import account from './modules/account'
import interfere from './modules/interfere'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    account,
    interfere
  }
})

export default store



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/index.ts